import React from 'react';
import PropTypes from 'prop-types';
import './LinkComponent.scss';
import { Link } from 'react-router-dom';
import { openInNewTab } from '../../../../../utils/openInNewTab';

function LinkComponent({ link, name, icon }) {
  return (
    <li className='link'>
      <Link onClick={() => openInNewTab(link)} className={name}>
        {icon}
      </Link>
    </li>
  );
}

LinkComponent.propTypes = {
  link: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
};

export default LinkComponent;
